/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum VerificationStatus {
  PENDING = "pending",
  VERIFIED = "verified",
  NOT_VERIFIED = "not_verified",
}
